/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const mediaAndText = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M3 6v11.5h8V6H3Zm11 3h7V7.5h-7V9Zm7 3.5h-7V11h7v1.5ZM14 16h7v-1.5h-7V16Z" />
	</SVG>
);

export default mediaAndText;
